  export class EmployeeList {
      public empNo: any;
      public empName: any;
      public emailID: any;
      public role: any;
      public businessUnit: any;
      public empStatus: any;
      public showProject: boolean;
      public showEmployee: boolean;
      public employees = [];
      public projects = [];
      constructor(data: any) {
          this.empNo = data.Empno ? data.Empno : '';
          this.empName = data.Empname ? data.Empname : '';
          this.emailID = data.EmailID ? data.EmailID : '';
          this.role = data.Role ? data.Role : '';
          this.businessUnit = data.businessUnit ? data.businessUnit : '';
          this.empStatus = data.Employment_Status ? data.Employment_Status : '';
          this.showProject = data.showProject ? data.showProject : false;
          this.showEmployee = data.showEmployee ? data.showEmployee : false;
          this.employees = data.employee ? data.employee : [];
          this.projects = data.projects ? data.projects : [];
      }
  }

  export class ExportIpdoDetailedView {
    public 'Approval Status': string;
    public 'Email ID': string;
    public 'Employee Name': string;
    public 'Employee No': number;
    public 'Filled Hrs': number;
    public 'Leave Details': string;
    public 'Project Name': string;
    public 'Timesheet Date': any;
    public 'Activity Name': string;
    public 'Business Unit': string;
    public 'Emp Status': string;
    public 'Personnel Area': string;
    public 'Personnel Sub Area': string;
    public 'Employee Sub Group': string;
    public 'Team': string;

    constructor(d: any = {}, flag: any) {
        this['Employee Name'] = d.empName || '';
        this['Employee No'] = d.empno || '';
        this['Email ID'] = d.emailID || '';
        this['Business Unit'] = d.businessUnit || '';
        this['Filled Hrs'] = d.filledHrs || '';
        this['Leave Details'] = d.leaveDetails || '';
        this['Project Name'] = d.projectName || '';
        this['Emp Status'] = d.employeeStatus || '';
        this['Personnel Area'] = d.personnelArea || '';
        this['Personnel Sub Area'] = d.personnelSubarea || '';
        this['Employee Sub Group'] = d.employeeSubgroup || '';
        this['Team'] = d.Team ? d.Team : '';

        if (flag === 0) {
            this['Activity Name'] = d.activityName || '';
        } else if (flag === 1) {
            delete this['Activity Name'];
        }

        if (d.timesheetenteredDate) {
          const isoDate = new Date(d.timesheetenteredDate);
          const day = isoDate.getDate().toString().padStart(2, '0'); // Ensure two digits for the day
          const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          const month = monthNames[isoDate.getMonth()];
          const year = isoDate.getFullYear();

          this['Timesheet Date'] = `${day}-${month}-${year}`;
        } else {
          this['Timesheet Date'] = '';
        }



        this['Approval Status'] = d.approvalStatus || '';

        if(d.businessUnit=="ipdo" && d.createdDate)
        {
        //this['SubmittedDate']=d.createdDate || '';
        const isoDate = new Date(d.createdDate);
          const day = isoDate.getDate().toString().padStart(2, '0'); // Ensure two digits for the day
          const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          const month = monthNames[isoDate.getMonth()];
          const year = isoDate.getFullYear();

          this['Submission Date'] = `${day}-${month}-${year}`;

          //this['LastLoginTime']=d.lastlogindate;
        }
        else
        {
          this['Submission Date']="";
        }
        if(d.businessUnit=="ipdo" && d.lastlogindate)
        {
          this['LastLoginTime']=d.lastlogindate;
        }
        else{
          this['LastLoginTime']="";
        }




        if (this['Business Unit'] == 'ipdo' || d.businessUnit === 'biologics' || d.businessUnit === 'chinateam' ||  d.businessUnit == 'aps') {
            delete this['Business Unit'];
        }

        if ( d.businessUnit === 'biologics') {
          delete this['Employee Sub Group'];
          this['Program Name'] = d.programName ? d.programName : '';
          this['Project Manager Name'] = d.projectManager ? d.projectManager : '';
          this['Position Description'] =  d.positionDescription ? d.positionDescription : '';
          this['Employee L+1'] =  d.RMname ? d.RMname : '';
          this['Cost Center'] =  d.costCenterText ? d.costCenterText : '';
          this['Cost Center Text'] =  d.costCenter ? d.costCenter : '';
          this['Department'] =  d.department ? d.department : '';
          this['Level 3 Text'] = d.levelThree ? d.levelThree: '';
        }

    }
  }

  export class ExportAnalyticscoeDetailedView {
    public 'Approval Status': string;
    public 'Email ID': string;
    public 'Employee Name': string;
    public 'Employee No': string;
    public 'Filled Hrs': string;
    public 'Leave Details': string;
    public 'Project Name': string;
    public 'Timesheet Date': string;
    public 'Activity Name': string;
    public 'Business Unit': string;
    public 'Emp Status': string;
    public 'from Time': string;
    public 'to Time': string;
    public 'Target': any;
    public 'RMname': string;
    public 'Submission Date': string;

    constructor(d: any = {}, flag: any) {
      this['Employee Name'] = d.empName || '';
      this['Employee No'] = d.empno_legacy || d.empno || '';
      this['Email ID'] = d.emailID || '';
      this['Project Name'] = d.projectName || '';
      this['Business Unit'] = d.businessUnit || '';
      this['Filled Hrs'] = d.filledHrs || '';
      this['Approval Status'] = d.approvalStatus || '';
      this['RMname'] = d.RMname || '';
      this['Leave Details'] = d.leaveDetails || '';

      // ✅ Always include Target column — null if missing or empty
      this['Target'] =
        d.hasOwnProperty('targetID') && d.targetID !== undefined && d.targetID !== ''
          ? d.targetID
          : null;

      // ✅ Activity Name — include only when needed
      if (flag === 1) {
        this['Activity Name'] = d.activityName || '';
      } else {
        this['Activity Name'] = '';
      }

      // ✅ Special handling for analyticscoe PTO
      if (d.businessUnit === 'analyticscoe' && d.activityName === 'Personal Time Off') {
        this['Activity Name'] = 'Personal Time Off';
      }

      // ✅ Timesheet date format (from timesheetenteredDate)
      if (d.timesheetenteredDate) {
        const isoDate = new Date(d.timesheetenteredDate);
        this['Timesheet Date'] = this.formatDate(isoDate);
      } else {
        this['Timesheet Date'] = '';
      }

      // ✅ Submission Date (from timesheetSubmissionDate or createdDate)
      const submissionDate = d.timesheetSubmissionDate || d.createdDate;
      if (submissionDate) {
        const isoDate = new Date(submissionDate);
        this['Submission Date'] = this.formatDate(isoDate);
      } else {
        this['Submission Date'] = '';
      }
    }

    private formatDate(date: Date): string {
      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
  }


  // export class Timesheet {
  //   public 'Approval Status': string;
  //   public 'Email ID': string;
  //   public 'Employee Name': string;
  //   public 'Employee No': number;
  //   public 'Filled Hrs': any;
  //   public 'Leave Details': string;
  //   public 'Project Name': string;
  //   public 'Timesheet Date': any;
  //   public 'Activity Name': string;
  //   public 'Business Unit': string;
  //   public 'Support Group': string;
  //   public 'Ticket No': string;
  //   public 'from Time':any;
  //   public 'to Time':any;
  //   public 'Target':any;
  //   public 'Daily Metrics': any;
  //   constructor(d: any = {}, flag: any) {
  //       this['Employee Name'] = d.empName || '';
  //       this['Employee No'] = d.empno || '';
  //       this['Email ID'] = d.emailID || '';
  //       this['Business Unit'] = d.businessUnit || '';
  //       if (d.businessUnit === 'accenture') {
  //           this['Filled Hrs'] = parseFloat(d.filledHrs).toFixed(1) || '';
  //       } else if (d.businessUnit === 'ipdo' || d.businessUnit === 'biologics' || d.businessUnit === 'chinateam' ||  d.businessUnit == 'aps') {
  //           this['Filled Hrs'] = d.filledHrs || '';
  //       }
  //       //this['Leave Details'] = d.leaveDetails || '';
  //       this['Project Name'] = d.projectName || '';
  //       if (flag === 0) {
  //           this['Activity Name'] = d.activityName || '';
  //           if (this['Business Unit'] === 'accenture') {
  //               this['Ticket No'] = d.ticketNumber || '';
  //               this['Support Group'] = d.supportGroup || '';
  //           }
  //       } else if (flag === 1) {
  //           delete this['Activity Name'];
  //       }
  //       this['Target']=d.targetID||"";
  //       if (d.businessUnit === 'analyticscoe') {
  //         if (d.activityName === "Personal Time Off") {
  //             this['Activity Name'] = d.activityName;
  //             //this['Leave Details'] = "Leave";
  //         } else {
  //             this['Activity Name'] = d.activityName || '';
  //         }
  //     }

  //     this['Filled Hrs'] = d.filledHrs || '';
  //       this['Timesheet Date'] = new Date(d.timesheetenteredDate).getDate() + '-'
  //           + (new Date(d.timesheetenteredDate).getMonth() + 1) + '-'
  //           + new Date(d.timesheetenteredDate).getFullYear() || '';
  //       this['Approval Status'] = d.approvalStatus || '';
  //       this['Daily Metrics'] = d.dailyMetrics ? JSON.stringify(d.dailyMetrics) : '{}';


  //       if (this['Business Unit'] === 'ipdo' || d.businessUnit === 'biologics' || d.businessUnit === 'chinateam' ||  d.businessUnit == 'aps' ||d.businessUnit=="analyticscoe") {
  //           delete this['Business Unit'];
  //       }
  //   }
  // }
  export class Timesheet {
    public 'Employee Name': string;
    public 'Employee No': string;
    public 'Email ID': string;
    public 'Project Manager': string;
    public 'Filled Hrs': string;
    public 'Leave Details': string;
    public 'EmpDepartment': string;
    public 'Client': string;
    public 'ClientEmailID': string;
    public 'Project Name': string;
    public 'Project Type': string;
    public 'Activity Name': string;
    public 'Timesheet Date': string;
    public 'Submission Date': string;
    public 'Approval Status': string;
    public 'Emp Status': string;
    public 'Target ID': string;
    public 'Steps': number | string;
    public 'Reactions': number | string;
    public 'Prod Reactions': number | string;
    public 'Successful Reactions': number | string;

    constructor(d: any = {}, flag: any) {
      this['Employee Name'] = d.empName || '';
      this['Employee No'] = d.empno_legacy || d.empno || '';
      this['Email ID'] = d.emailID || '';
      this['Project Manager'] = d.projectManager || '';
      this['Filled Hrs'] = d.filledHrs || '';
      this['Leave Details'] = d.leaveDetails || '';
      this['EmpDepartment'] = d.EmpDepartment || '';
      this['Client'] = d.client || '';
      this['ClientEmailID'] = d.clientEmailID || '';
      this['Project Name'] = d.projectName || '';
      this['Project Type'] = d.projectType || '';
      this['Activity Name'] = d.activityName || '';
      this['Approval Status'] = d.approvalStatus || '';
      this['Emp Status'] = d.employeeStatus || '';
      this['Target ID'] = d.targetID || '';
      const tsDate = d.timesheetenteredDate
      ? new Date(d.timesheetenteredDate)
      : null;
    const subDate = d.timesheetSubmissionDate
      ? new Date(d.timesheetSubmissionDate)
      : null;

    this["Timesheet Date"] = tsDate
      ? `${tsDate.getDate()}-${tsDate.getMonth() + 1}-${tsDate.getFullYear()}`
      : "";
    this["Submission Date"] = subDate
      ? `${subDate.getDate()}-${subDate.getMonth() + 1}-${subDate.getFullYear()}`
      : "";

  // ✅ Flatten dailyMetrics safely
  // ✅ Flatten dailyMetrics safely (no nullish coalescing)
  const metrics = d.dailyMetrics || {};
  this['Steps'] = (metrics.stepsCompleted !== undefined && metrics.stepsCompleted !== null) ? metrics.stepsCompleted : '';
  this['Reactions'] = (metrics.reactionsPerformed !== undefined && metrics.reactionsPerformed !== null) ? metrics.reactionsPerformed : '';
  this['Prod Reactions'] = (metrics.productiveReactions !== undefined && metrics.productiveReactions !== null) ? metrics.productiveReactions : '';
  this['Successful Reactions'] = (metrics.successfulReactions !== undefined && metrics.successfulReactions !== null) ? metrics.successfulReactions : '';

    }

  }

  export class PendingTimesheet {
    public selectedstartDate: string;
    public selectedendDate: string;
    public flag: number;
    public empno: number;
    public pageSize:number;
    public pageNumber: number;
    public reportExport: boolean;
    constructor(d: any = {}) {
        this.selectedendDate = d.selectedendDate || '';
        this.selectedstartDate = d.selectedstartDate || '';
        this.flag = d.flag || 0;
        this.empno = d.empno || null;
        this.pageSize = d.pageSize || null;
        this.pageNumber = d.pageNumber || null;
        this.reportExport = d.reportExport || false;
    }
  }


  export class ExportData {
    public data: Array<any>;
    public fileName: string;
    public pageHeading: string;
    public flag: boolean;
    constructor(d: any = {}) {
        this.data = d.data || [];
        this.fileName = d.fileName || '';
        this.pageHeading = d.pageHeading || '';
        this.flag = d.flag || true;
    }
  }


  export class EmployeeProject {
      public projectId: any;
      public projectName: any;
      public totalHrs: any;
      public activities = [];
      public showActivity: boolean;
      constructor(data: any) {
          this.projectId = data.projectID ? data.projectID : '';
          this.projectName = data.projectname ? data.projectname : '';
          if (!!data.totalHrs) {
              const totalHrsconvertValue = this.convertHoursToMins(data.totalHrs);
              this.totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
          }
          this.activities = data.activity_hrs ? data.activity_hrs : [];
          this.activities.forEach(element => {
              const totalHrsconvertValue = this.convertHoursToMins(element.FilledHrs);
              element.FilledHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
          });
          this.showActivity = data.showActivity ? data.showActivity : false;
      }

      convertHoursToMins(hrs) {
          const a = hrs.toString().split(':');
          let minutes = 0;
          if (a[1]) {
              minutes = (+(a[0])) * 60 + (+a[1]);
          } else {
              minutes = (+(Number(a[0]))) * 60;
          }
          return minutes;
      }

      convertMinsToHrsMins(mins) {
          const h: any = Math.floor(mins / 60);
          let m: any = mins % 60;
          m = Math.round(m);
          const hrs = h < 10 ? '0' + h : h;
          const mns = m < 10 ? '0' + m : m;
          return `${hrs}:${mns}`;
      }
  }




// WEBPACK FOOTER //
// ./src/app/rm/timesheet-report/timesheet-report.ts